module.exports = __webpack_public_path__ + "img/9788991239906.2ddcb303.jpg";